export default __webpack_public_path__ + "static/media/logoWithText.54c373ec.svg";